import { useContext, createContext } from 'react';

/** Объект урлов вида { offerId: ссылка_на_детальную_страницу } */
export type TUrlMap = Record<string | number, string>;

export const UrlMapperContext = createContext<TUrlMap>({});
export const useUrlMapperContext = () => useContext(UrlMapperContext);
